module.exports = __webpack_public_path__ + "static/media/Contact_Us_default.201804c8.svg";